import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/settings/_layout/')({
  component: () => null,
});
